<template>
  <router-view />
  <ChatWidget v-if="isStudent" :userName="userName" />
</template>

<script setup lang="js">
import { onMounted, onBeforeUnmount, computed } from "vue";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import { useStore } from "vuex";
import useAutoLogout from "@/composables/useAutoLogout";
import rightClickProtection from "@/mixins/rightClickProtection";
import ChatWidget from "@/components/Student/ChatBot.vue";

useAutoLogout();
rightClickProtection();

const firebaseConfig = {
  apiKey: "AIzaSyCXdd35P5bRank6PMcDCBo_zAeW9E7lQmA",
  authDomain: "galectalms.firebaseapp.com",
  projectId: "galectalms",
  storageBucket: "galectalms.firebasestorage.app",
  messagingSenderId: "77197920870",
  appId: "1:77197920870:web:baf432cb57a16aa7e73ba7",
  measurementId: "G-XY4T4BNMM4"
};

const store = useStore();
const isStudent = computed(() => {
  return store.getters.isAuthenticated && store.getters.userInfo?.user?.permission === 'student';
});
const userName = computed(() => {
  return store.getters.userInfo?.user?.first_name || 'Student';
});


// try {
//   const app = initializeApp(firebaseConfig);
//   const messaging = getMessaging(app);

//   if ('serviceWorker' in navigator) {
//     navigator.serviceWorker.register('/firebase-messaging-sw.js')
//       .then(registration => {
//         console.warn('Service Worker registered with scope:', registration.scope);
//       })
//       .catch(error => {
//         console.error('Service Worker registration failed:', error);
//       });

//     // Handle incoming messages
//     onMessage(messaging, (payload) => {
//       console.log('Message received. ', payload);
//     });

//     // Get and store token
//     getToken(messaging, { vapidKey: "BI2OLF_C6sZrc8hsydIGsNkuWhKSJ4q_F535hwzXNL-XS5lafFl8EX9IsVZaQ6BnsRZbCCKlYlo26nZE1AABD34" }).then((currentToken) => {
//       if (currentToken) {
//         // console.log("Token is:", currentToken);
//         localStorage.setItem("message_token", currentToken);
//       } else {
//         console.log('No registration token available. Request permission to generate one.');
//       }
//     }).catch((err) => {
//       console.error('An error occurred while retrieving token. ', err);
//     });
//   } else {
//     console.warn('Service workers are not supported in this browser.');
//   }
// } catch (error) {
//   console.error('Firebase initialization error:', error);
// }

const initFirebaseMessaging = async () => {
  try {
    const supported = await isSupported();
    if (!supported) {
      console.warn('Firebase Messaging is not supported in this browser.');
      return;
    }

    if (!('serviceWorker' in navigator)) {
      console.warn('Service workers are not supported in this browser.');
      return;
    }

    const app = initializeApp(firebaseConfig);
    const messaging = getMessaging(app);

    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    console.warn('Service Worker registered with scope:', registration.scope);

    onMessage(messaging, (payload) => {
      console.log('Foreground message received:', payload);
    });

    const currentToken = await getToken(messaging, {
      vapidKey: "BI2OLF_C6sZrc8hsydIGsNkuWhKSJ4q_F535hwzXNL-XS5lafFl8EX9IsVZaQ6BnsRZbCCKlYlo26nZE1AABD34",
      serviceWorkerRegistration: registration
    });

    if (currentToken) {
      localStorage.setItem("message_token", currentToken);
    } else {
      console.log('No token available. Request permission to generate one.');
    }

  } catch (error) {
    console.error('Firebase initialization error:', error);
  }
};

onMounted(async () => {
  initFirebaseMessaging();
  console.log("App loaded or browser refreshed");
  await store.dispatch('initializeApp');
  console.log("App initialization complete");
});

onBeforeUnmount(() => {
  console.log('Cleaning up WebSocket connection...');
  store.commit('closeWebSocket');
});
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap");

* {
  font-family: "Inter", serif;
}
</style>
